import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { green } from "@material-ui/core/colors";
import { red } from "@material-ui/core/colors";
import { Link } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Modal from "./GateModel";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../components/components.js";
import smartParkService from "../../axios";
import IconButton from "@material-ui/core/IconButton";
import { Clear, OpenInNewRounded } from "@material-ui/icons";
import { login_, token_ } from "../../reducers/login";
import _ from "lodash";
import "../../assets/scss/App.scss";
import {
  permissions_,
  hasLoadedpermissions_,
} from "../../reducers/permissions";
import ToggleModal from "../../components/Modals/ToggleModal";
import { checkPermissions } from "../../utils/checkPermissions.js";
import { GenerateEncryptedToken } from "../Common.js";
const ButtonLink = withStyles((theme) => ({
  root: {
    display: "inline !important",
    color: "blue !important",
    marginRight: "10px !important",
    padding: "0 !important",
    textDecoration: "underline",
    border: "none !important",
    fontSize: "13px !important",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px !important",
    },
  },
}))(Link);

const useStyles = makeStyles(styles);

export default function GateStatus(props) {
  const loginDetails = useSelector(login_);
  const parkid = _.get(loginDetails, ["parkID"], "");
  const classes = useStyles();
  const { parkID } = props;
  const token = GenerateEncryptedToken();
  smartParkService.defaults.headers.common["x-access-token"] = token;
  const [devicestatus, setdevicestatus] = React.useState({});
  const [status, setstatus] = React.useState([]);
  const [permission, setpermission] = React.useState({});
  const [open, setopen] = React.useState(false);
  const [Openorclose, setOpenorclose] = React.useState("");
  const [devicename, setdevicename] = React.useState([]);
  const [Iselectall, setIselectall] = React.useState(false);
  const [btnopenactive, setopenbtnactive] = React.useState(false);
  const [btncloseactive, setclosebtnactive] = React.useState(false);
  const [allChecked, setallChecked] = React.useState(false);
  const permissionsHasLoaded = useSelector(hasLoadedpermissions_);
  const permissionsobj = useSelector(permissions_);

  const getFields = () => {
    var url = "api/park/" + parkID + "/device";
    smartParkService
      .get(url)
      .then((res) => {
        if (res.status === 200) {
          var data = res.data.data;
          var dataconst = data.map((d) => {
            return {
              deviceID: d.deviceID,
              isChecked: false,
              devicename: d.devicename,
              devicestatus: d.devicestatus,
            };
          });
          setdevicename(dataconst);
        }
      })
      .catch((error) => {});
  };
  const getpermissions = async () => {
    const permissionsobject = permissionsobj;
    var Dpermissions = permissionsobject.filter(function (e) {
      return e.feature == "GateStatus";
    });
    setpermission(Dpermissions[0]);
  };
  React.useEffect(() => {
    if (permissionsHasLoaded && permissionsobj && permissionsobj.length > 0) {
      getpermissions();
    }
  }, [permissionsHasLoaded]);
  const handleClose = () => {
    setopen(false);
    setallChecked(false);
    setopenbtnactive(false);
    setclosebtnactive(false);
    getFields();
  };
  const handleFieldopen = () => {
    let toggleAllowed = false;
    devicename.forEach((device) => {
      if (device.isChecked === true && btncloseactive) {
        toggleAllowed = true;
        setFieldData((prevState) => [
          ...prevState,
          {
            deviceType: "Gate",
            park_id: parkID,
            primaryStatus: device.devicestatus,
            updateStatus: "Open",
            field_name: device.devicename,
            field_status: device.devicestatus,
            field_id: device.deviceID,
            url_suffix: "/updatedevice",
          },
        ]);
      }
    });
    if (toggleAllowed && btncloseactive) {
      setModalStatus(true);
    }
    // var isListChecked = false;
    // if (
    //   devicename.filter(function (obj) {
    //     if (obj.isChecked) isListChecked = true;
    //   })
    // );
    // if (isListChecked) {
    //   setOpenorclose("Open");
    //   setopen(true);
    // }
  };
  const handleFieldClose = () => {
    let toggleAllowed = false;
    devicename.forEach((device) => {
      if (device.isChecked === true && btnopenactive) {
        toggleAllowed = true;
        setFieldData((prevState) => [
          ...prevState,
          {
            deviceType: "Gate",
            park_id: parkID,
            primaryStatus: device.devicestatus,
            updateStatus: "Closed",
            field_name: device.devicename,
            field_status: device.devicestatus,
            field_id: device.deviceID,
            url_suffix: "/updatedevice",
          },
        ]);
      }
    });
    if (toggleAllowed && btnopenactive) {
      setModalStatus(true);
    }
    // var isListChecked = false;
    // if (
    //   devicename.filter(function (obj) {
    //     if (obj.isChecked) isListChecked = true;
    //   })
    // );
    // if (isListChecked) {
    //   setOpenorclose("Closed");
    //   setopen(true);
    // }
  };
  const handleChange = (e) => {
    let itemName = e.target.name;
    let checked = e.target.checked;
    let devicename1 = devicename;
    let allChecked1 = allChecked;
    if (itemName === "checkAll") {
      allChecked1 = checked;
      devicename1 = devicename.map((item) => ({
        ...item,
        isChecked: checked,
      }));
    } else {
      devicename1 = devicename.map((item) =>
        item.deviceID === itemName ? { ...item, isChecked: checked } : item
      );
      allChecked1 = devicename1.every((item) => item.isChecked);
    }

    setopenbtnactive(false);
    setclosebtnactive(false);
    devicename1.map((item) => {
      if (item.devicestatus === "Open") {
        if (item.isChecked == true) {
          setopenbtnactive(true);
          // setclosebtnactive(true);
        }
      } else if (item.devicestatus === "Closed") {
        if (item.isChecked == true) {
          // setopenbtnactive(true);
          setclosebtnactive(true);
        }
      }
    });

    setdevicename(devicename1);
    setallChecked(allChecked1);
  };
  const updateStateList = (e, value) => {
    if (e.target.checked) {
      //append to array
      // this.setState({
      //   status: status.concat([value]),
      // });
      setstatus(status.concat([value]));
    } else {
      //remove from array

      setstatus(
        status.filter(function (val) {
          return val !== value;
        })
      );
    }
  };
  React.useEffect(() => {
    getFields();
  }, [devicestatus]);
  React.useEffect(() => {
    setopenbtnactive(false);
    setclosebtnactive(false);
  }, []);
  const [modalStatus, setModalStatus] = useState(false);
  const userid = _.get(loginDetails, ["UserID"], "");
  const [fieldData, setFieldData] = useState([]);
  const firstname = _.get(loginDetails, ["FirstName"], "");
  const lastname = _.get(loginDetails, ["LastName"], "");
  const toggleHandler = async (e) => {
    const overrideActions = Object.values(toggleCheckBoxData).filter(
      (checkbox) => {
        if (checkbox.value) {
          return checkbox;
        }
      }
    );
    let url = `api/park/${e[0].park_id}${e[0].url_suffix}`;
    const data = {
      overrideActions: overrideActions[0].name,
      LastEditedBy: `${firstname} ${lastname}`,
      disableNotification: false,
      deviceIDs: [],
      gates: [],
      status: e[0].updateStatus,
    };
    e.forEach((gateData) => {
      data.gates.push(gateData.field_name);
      data.deviceIDs.push(gateData.field_id);
    });
    await smartParkService
      .post(url, data, {
        headers: {
          userid: userid,
          "x-access-token": token,
        },
      })
      .then((res) => {
        if (Number(res.status) === 200) {
          getFields();
          handleChange({ target: { checked: false, name: "checkAll" } });
        }
      });
  };
  const handleCheckbox = (e) => {
    Object.keys(toggleCheckBoxData).map((checkbox) => {
      if (e.target.checked) {
        setToggleCheckBoxData((prevdata) => ({
          ...prevdata,
          [checkbox]: {
            ...prevdata[checkbox],
            value: checkbox === e.target.name ? e.target.checked : false,
          },
        }));
      } else {
        setToggleCheckBoxData((prevState) => ({
          ...prevState,
          [e.target.name]: {
            ...prevState[e.target.name],
            value: e.target.checked,
          },
        }));
      }
    });
  };
  const closeModal = () => {
    setFieldData([]);
    setModalStatus(false);
  };
  const [toggleCheckBoxData, setToggleCheckBoxData] = useState({
    Block: { name: "Block", label: "Block rule actions", value: false },
    Unblock: { name: "Unblock", label: "Unblock rule actions", value: false },
  });
  const checkBoxDescription = [
    "The automatic rules have actions that can open or close the devices.",
    "Do you want to block the actions of those rules?",
  ];
  const helpText = [
    `If you chose to block, then gates, fields, park will remain ${
      fieldData[0]?.updateStatus
        ? fieldData[0].updateStatus
        : "in [open/closed] state"
    }, until the next manual change.`,
    "If you chose to unblock the rule actions, the gates, fields, park will change state based on the rules. This manual action will be overridden.",
  ];

  return (
    <div>
      {/*<Modal*/}
      {/*  show={open}*/}
      {/*  status={devicename}*/}
      {/*  closePopup={handleClose}*/}
      {/*  openclose={Openorclose}*/}
      {/*/>*/}
      <ToggleModal
        submitButtonHandler={(e) => {
          toggleHandler(e);
        }}
        handleCheckbox={handleCheckbox}
        disableData={fieldData}
        closeModalHandler={closeModal}
        checkBoxData={toggleCheckBoxData}
        checkBoxDescription={checkBoxDescription}
        modalState={modalStatus}
        checkBoxHelpText={helpText}
      />
      <div class="box">
        <div class="box-header text-center">
          <h6 class="">Gate Status</h6>
          {checkPermissions({
            permission: "GateStatus",
            permissionType: "update",
          }) && (
            <div class="text-center" style={{ marginBottom: "-10px" }}>
              <ButtonLink
                onClick={handleFieldopen}
                className={`${classes.openclosedisabled} ${
                  btncloseactive === true ? classes.blueButton : ""
                } `}
              >
                Open Gates
              </ButtonLink>

              <ButtonLink
                onClick={handleFieldClose}
                className={`${classes.openclosedisabled} ${
                  btnopenactive === true ? classes.redButton : ""
                } `}
              >
                Close Gates
              </ButtonLink>
            </div>
          )}
        </div>
        <div class="box-body">
          <div class="divGrid">
            <div class="divGridHeading">
              <div class="divGridRow">
                <div class="divGridHead">
                  {checkPermissions({
                    permission: "GateStatus",
                    permissionType: "update",
                  }) && (
                    <Checkbox
                      color="primary"
                      style={{ padding: "2px" }}
                      checked={allChecked}
                      name="checkAll"
                      onChange={(e) => handleChange(e)}
                    />
                  )}
                  Gate
                </div>
                <div class="divGridHead">Status</div>
              </div>
            </div>
            <div class="divGridBody">
              {devicename.map((m) => (
                <div class="divGridRow">
                  <div class="divGridCell">
                    {checkPermissions({
                      permission: "GateStatus",
                      permissionType: "update",
                    }) && (
                      <Checkbox
                        color="primary"
                        name={m.deviceID}
                        checked={m.isChecked}
                        style={{ padding: "2px" }}
                        key={m.devicename}
                        onChange={(e) => handleChange(e)}
                      />
                    )}
                    {m.devicename}
                  </div>
                  <div class="divGridCell">
                    <div class="d-flex">
                      <FiberManualRecordIcon
                        fontSize="small"
                        style={{
                          color:
                            m.devicestatus === "Open" ? green[500] : red[500],
                        }}
                      />{" "}
                      {m.devicestatus}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
